// LIBRARIES //
import React, { Component } from 'react';
import capitalize from 'capitalize';

// COMPONENTS //
import FlatButton from 'material-ui/FlatButton';
import { MdRemoveCircle as UnverifiedIcon } from 'react-icons/md';
import { MdCheckCircle as VerifiedIcon } from 'react-icons/md';

// HELPER //
import { AccentColor } from 'helpers/AccentColorHelper';
import { formatMoney, formatPhone } from 'helpers/Formatter';

// STYLE //
import './ReviewApplicants.css';

class LandlordReference extends Component {
  verifiedIcon(applicant) {
    if (applicant.verified) {
      return <VerifiedIcon style={{ color: '#3dce3d' }} />;
    } else {
      return <UnverifiedIcon style={{ color: AccentColor() }} />;
    }
  }

  applicantDescription = (landlord_reference) => {
    return (
      `${capitalize(
        this.props.cotenantName
      )} stayed here for ${landlord_reference.length_of_stay.toLowerCase()}` +
      ` and paid ${formatMoney(landlord_reference.rental_amount)}/month.`
    );
  };

  render() {
    const applicant_landlord_references = this.props.applicant_data;

    const style = {
      row: {
        padding: '0 15px',
        marginTop: '30px',
      },
      header: {
        color: '#4e4e4e',
        fontSize: '18px',
        marginBottom: '0',
        marginTop: '0',
      },
      sub_header: {
        marginTop: '5px',
        marginBottom: 0,
        color: '#6F6F6F',
        textAlign: 'justify',
        overflowWrap: 'break-word',
      },
      sub_header_last: {
        marginTop: '10px',
        marginBottom: 0,
        color: '#6F6F6F',
      },
      button_container: {
        padding: '30px 15px 10px 15px',
        marginTop: '-10px',
        textAlign: 'center',
      },
      button: {
        backgroundColor: AccentColor(),
        color: '#fff',
      },
      padding_left: {
        padding: '15px 0px 0 0',
        textAlign: 'left',
      },
      titleContentStyle: {
        borderBottom: '0px solid #e0e0e0',
        padding: '20px 20px 5px 20px',
        textAlign: 'center',
        color: '#4e4e4e',
      },
      customContentStyle: {
        maxWidth: '400px',
        width: '95%',
      },
      bodyContentStyle: {
        padding: '10px 20px 20px 20px',
        textAlign: 'center',
      },
      deletebodyContentStyle: {
        padding: '20px 5px 0px 5px',
        textAlign: 'center',
      },
      subMenuHeader: {
        backgroundColor: '#f7f7f7',
        margin: '20px -15px',
        textAlign: 'center',
        color: '#888888',
      },
    };

    let landlord_references;
    if (applicant_landlord_references.length !== 0) {
      landlord_references = Object.keys(applicant_landlord_references).map((key) => (
        <div key={key} className="row" style={style.row}>
          <div className="wrapper">
            <h5 style={style.header}>
              {capitalize(applicant_landlord_references[key].name)}
              <span style={{ verticalAlign: 'super', marginLeft: '3px' }}>
                {this.verifiedIcon(this.props.applicant_data[key])}
              </span>
            </h5>
            <h5 style={style.sub_header}>{applicant_landlord_references[key].email}</h5>
            <h5 style={style.sub_header}>
              {formatPhone(applicant_landlord_references[key].phone_number)}
            </h5>
            <div className="second">
              <h5 style={style.header}>
                {' '}
                {this.props.applicant_data[key].is_current_reference === true
                  ? 'Current '
                  : ''}{' '}
                Landlord Reference{' '}
              </h5>
              <h5 style={style.sub_header}>
                {' '}
                {this.props.applicant_data[key].verified ? 'Verified!' : 'Pending Verification'}
              </h5>
              <h5 style={style.sub_header_last}>
                {' '}
                {this.applicantDescription(this.props.applicant_data[key])}{' '}
              </h5>
            </div>
          </div>

          <div className="row" id="add_landlord_button" style={style.button_container}>
            {!this.props.applicant_data[key].verified && (
              <FlatButton
                label={<span>Verify Reference</span>}
                onClick={() => {
                  this.props.approveReference(
                    this.props.applicantId,
                    'landlord_information',
                    this.props.applicant_data[key].id
                  );
                }}
                primary={true}
                style={style.button}
              />
            )}
          </div>
        </div>
      ));
    } else {
      landlord_references = (
        <div className="small-message">
          <small>Landlord references not provided.</small>
        </div>
      );
    }

    return (
      <div>
        <div className="row" style={style.subMenuHeader}>
          <h5> Landlord Information </h5>
        </div>

        {landlord_references}
      </div>
    );
  }
}

export default LandlordReference;
